import { jsx } from "react/jsx-runtime";
import cx from "classnames";
const defaultMessages = {
  new: "New",
  nlp: "New lower price",
  family: "IKEA Family price"
};
const CommercialMessage = (props) => {
  const { prefix = "", message, variant = "new", subtle, className } = props;
  const cssStyles = cx(
    className,
    `${prefix}commercial-message`,
    subtle && `${prefix}commercial-message--subtle`,
    `${prefix}commercial-message${subtle ? "--subtle" : ""}--${variant}`
  );
  return /* @__PURE__ */ jsx("div", { className: cssStyles, children: /* @__PURE__ */ jsx("span", { className: `${prefix}commercial-message__title`, children: message || defaultMessages[variant] }) });
};
export {
  CommercialMessage
};
